import { Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { ChatService } from '../../../base/chatService';
import { SocketChatService } from '../../../base/socketChatService';
import { generateChatID, userInfo } from '../../../base/socketChatService/utils';
import { Cookie } from '../../../base/utils';
import { chatwindowDetails, initialStateModel, LoginState, typingReducerModel } from '../../../models/model';
import { URAvatarGroup } from '../../../shared/widgets/avatarGroup';
import { URStatusDot } from '../../../shared/widgets/avatarGroup/statusDot';
import styles from "./scss/chattopics.module.scss";
import teamIcn from "../../../styles/images/teamimg.svg";
import { userStatusColor } from '../../../base/callService/common';
import singleIcon from "../../../styles/images/Welaunch_Profile_Pic.svg";
import _ from 'lodash';
export default function Topleftside() {

  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const { typingList }: typingReducerModel = useSelector((state: initialStateModel) => state.typingReducerState);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const [showText, setTextChange] = useState(false);
  const socketService = useRef<any>(null);
  let { chatWindowDetails } = chatWindow;

  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
    setTextChange(false)
    setTimeout(function () {
      setTextChange(true)
    }, 5000);

  }, [chatWindowDetails]);
  const favContacts = (contactDetails: any) => {

    let chatId: any = contactDetails.sip_login_id ?
      generateChatID(userInfo().fromID, contactDetails?.sip_login_id.toString()) : contactDetails?.team_id.toString();
    let teamMemberFavourite = contactDetails?.team_members_favourite ? contactDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
    let chatDetails = {
      chatId: chatId,
      settingsKey: "isFavourite",
      toSipId: contactDetails?.sip_login_id ? contactDetails?.sip_login_id?.toString() : contactDetails?.team_id?.toString(),
      type: contactDetails?.sip_login_id ? 1 : 2,
      status: (contactDetails?.is_favourite || (Array.isArray(teamMemberFavourite) && teamMemberFavourite.length > 0 &&
        teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1)) ? 0 : 1,
      phoneNumber: contactDetails?.ext ? contactDetails?.ext : ""
    };
    const timer = setTimeout(() => {
      socketService.current.updateRecentChatSettings(chatDetails);
      socketService.current.toastUndo("", "")
    }, 3000);
    if ((!contactDetails?.is_favourite && contactDetails?.sip_login_id) || ((Array.isArray(teamMemberFavourite) &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id) === -1) && contactDetails?.team_id)) {
      socketService.current.toastUndo("Added to favourites", timer, 'favourite');
    } else {
      socketService.current.toastUndo("Removed from Favourites", timer, 'unfavourite');
    }


  }
  let keysData =
    Object.keys(typingList) && Object.keys(typingList).length > 0
      ? Object.values(typingList)
        .map((value: any) => {
          if (
            value?.msgType === 2 &&
            parseInt(chatWindowDetails?.team_id) === parseInt(value?.chatId) &&
            value?.participants
          ) {
            return Object.values(value.participants)
              .map((value: any) => value?.caller_id)
              .toString();
          } else {
            return null;
          }
        })
        .filter((value) => value)
      : [];
  let Name = chatWindowDetails?.caller_id || chatWindowDetails?.team_name || 'Unknown User';
  let teamMemberOnly = chatWindowDetails?.team_members ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  let teamMemberFavourite = chatWindowDetails?.team_members_favourite ? chatWindowDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
  let colorIndex = allReducer.recentChatTabReducer?.tabrecentindex !== undefined ? allReducer.recentChatTabReducer?.tabrecentindex > 7 ? (allReducer.recentChatTabReducer?.tabrecentindex - Math.floor((allReducer.recentChatTabReducer?.tabrecentindex / 8)) * 8) + 1
    : allReducer.recentChatTabReducer?.tabrecentindex + 1 : 1

  return (
    <>
      <div className={styles.lefts}>
        <div onClick={() => ChatService.rightSideToogle()}>
        {chatWindowDetails?.is_blocked === 1 ? 
            <URAvatarGroup className={`lefts size38 `} profileInfo={
                  <>
                   <img src={singleIcon} alt="" />
    
                  </>
                } />
        : 
          <URAvatarGroup className={`lefts size38 colorBG${colorIndex} 
        ${(chatWindowDetails?.ImageURL !== null && chatWindowDetails?.ImageURL !== '' && chatWindowDetails?.profile_image_url !== null && chatWindowDetails?.profile_image_url !== "") ? 'avatarWithImg' : ""}`} profileInfo={
              <>
                {(chatWindowDetails?.profile_image_url || chatWindowDetails?.ImageURL) ?
                  <img src={chatWindowDetails?.profile_image_url || chatWindowDetails?.ImageURL} alt="" />
                  : chatWindowDetails?.team_id ? <span className="teamImg"><img src={teamIcn} alt="team icon" /></span> :
                    <span>{chatWindowDetails?.first_name?.charAt(0).toUpperCase() + chatWindowDetails?.last_name?.charAt(0).toUpperCase()}</span>

                }
                {!chatWindowDetails?.team_id && <URStatusDot className={userStatusColor(chatWindowDetails?.user_status, 'small')} />}

              </>
            } /> }
        </div>
        <div>
          <div className={styles.frow}>
            {Name.length > 14 && <Tooltip title={Name}
              className='cusTooltip' overlayClassName='customTooltip tooltiptopsizesm'>
              <h4 title="View profile">{Name && Name.length > 40 ? Name.substring(0, 40) + "..." : Name}</h4>
            </Tooltip>}
            {Name.length < 15 &&
              <h4 title="View profile"  onClick={() => ChatService.rightSideToogle()}>{Name}</h4>
            }

            {chatWindowDetails?.team_id && teamMemberOnly.includes(userdetails.sip_login_id) ?
              <div className={styles.favIcons} onClick={e => e.preventDefault()}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={Array.isArray(teamMemberFavourite) &&
                  teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1 ? "Remove from Favourites"
                  : "Add to Favourites"} className='cusTooltip' overlayClassName='customTooltip'>
                  <span className={Array.isArray(teamMemberFavourite) &&
                    teamMemberFavourite.indexOf(userdetails?.sip_login_id) > -1 ? "icon_starfill starfontincrize cgreen" : "icon_star starfontincrize"}
                    onClick={() => favContacts(chatWindowDetails)}
                  ></span>
                </Tooltip> </div> :
              chatWindowDetails?.sip_login_id && 
              <div className={`${styles.favIcons}${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}  onClick={(e:any) => e.stopPropagation()}>

                <Tooltip mouseEnterDelay={0.5} placement="top" title={chatWindowDetails?.is_favourite === 0 ? 'Add to Favourites'
                  : "Remove from Favourites"}>
                  <span className={`${chatWindowDetails?.is_favourite === 0 ? "icon_star starfontincrize" : "icon_starfill starfontincrize cgreen"} ${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}
                    onClick={() => favContacts(chatWindowDetails)}
                  ></span>

                </Tooltip>
              </div>

            }

          </div>

          {/* <span className={styles.infoSec}>{showText && chatWindowDetails?.team_id?chatWindowDetails?.teammembersdetails?.length +" members":showText ?chatWindowDetails.user_status : "click here to view profile info"} </span>
         */}
          {chatWindowDetails?.team_id && Array.isArray(keysData) && keysData.length > 0 ? (
            <>
              <span className={styles.infoSec}>{_.startCase(_.toLower(keysData.join(",")))} is typing...</span>
            </>

          ) : Object.keys(typingList) && Object.keys(typingList).length > 0 &&  typingList?.[chatWindowDetails?.sip_login_id] ? (
            chatWindowDetails?.sip_login_id && Object.keys(typingList) && Object.keys(typingList).length > 0 &&
            typingList?.[chatWindowDetails?.sip_login_id] && (
              <>
                <span className={styles.infoSec}>typing...</span>
              </>

            ) 
          ) : chatWindowDetails?.is_blocked === 1 ? "": 
        
            <span className={styles.infoSec} onClick={() => ChatService.rightSideToogle()}>{showText && chatWindowDetails?.team_id ? chatWindowDetails?.teammembersdetails?.length + " members" : showText ? chatWindowDetails?.user_status :  "click here to view profile info"} </span>

          }
        </div>


        {/* {chatWindow.isNewMessageWindow !== true && !chatWindowDetails?.team_name &&
          (chatWindowDetails?.user_status === "Available"
            ?
            <div className="chatTopsts bgGreen" ></div>
            :
            chatWindowDetails?.user_status === "Appear Away"
              ?
              <div className="chatTopsts bgYello" ></div>
              :
              (chatWindowDetails?.user_status === "Appear Busy" || chatWindowDetails?.user_status === "In a call")
                ?
                <div className="chatTopsts bgRed" ></div> :
                (chatWindowDetails?.user_status === "Do not disturb")
                  ?
                  <span className={`chatTopsts bgdntRed`}></span>
                  :
                  <div className="chatTopsts bgGrey" ></div>)
        }
        {chatWindowDetails?.team_id && teamMemberOnly.includes(userdetails.sip_login_id) ?
          <Tooltip mouseEnterDelay={0.5} placement="top" title={Array.isArray(teamMemberFavourite) &&
            teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1 ? "Remove from Favourites"
            : "Add to Favourites"} className='cusTooltip' overlayClassName='customTooltip'>
            <span className={Array.isArray(teamMemberFavourite) &&
              teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1 ? "favcommon zoomIn icon_starfill" : "icon_star"}
              onClick={() => favContacts(chatWindowDetails)}
            ></span>
          </Tooltip> :
          chatWindowDetails?.sip_login_id &&
          <Tooltip mouseEnterDelay={0.5} placement="top" title={chatWindowDetails?.is_favourite === 0 ? 'Add to Favourites'
            : "Remove from Favourites"}>
            <span className={chatWindowDetails?.is_favourite === 0 ? "icon_star" : "favcommon zoomIn icon_starfill"}
              onClick={() => favContacts(chatWindowDetails)}
            ></span>
          </Tooltip>
        } */}

      </div>
    </>
  );
}
